import { OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ContactItemValidator } from '@validators/contact-item-validation';
import { sortBy } from 'lodash';
var TabContactsComponent = /** @class */ (function () {
    function TabContactsComponent(data, fb) {
        this.data = data;
        this.fb = fb;
        this.location = this.data.location;
    }
    TabContactsComponent.prototype.ngOnInit = function () {
        this.setContactItem('emails');
        this.setContactItem('phones');
        if (this.isViewMode) {
            this.contactForm.disable();
        }
    };
    TabContactsComponent.prototype.setContactItem = function (itemsName) {
        var _this = this;
        var isEmails = Boolean(itemsName === 'emails');
        if (!this.location) {
            return;
        }
        var contactItems = sortBy(this.location.contact[itemsName], 'primary').reverse();
        if (contactItems.length) {
            var someIsPrimary = contactItems.some(function (contactItem) { return contactItem.primary; });
            if (!someIsPrimary) {
                contactItems[0].primary = true;
            }
        }
        var contactItemsArray = this.fb.array(contactItems.map(function (contactItem) {
            if (isEmails) {
                return _this.fb.group({
                    emailAddress: _this.fb.control(contactItem.emailAddress, [Validators.required, Validators.email]),
                    name: _this.fb.control(contactItem.name),
                    contactType: _this.fb.control(contactItem.contactType, Validators.required),
                    primary: _this.fb.control(contactItem.primary)
                });
            }
            return _this.fb.group({
                number: _this.fb.control(contactItem.number, Validators.required),
                name: _this.fb.control(contactItem.name),
                contactType: _this.fb.control(contactItem.contactType, Validators.required),
                primary: _this.fb.control(contactItem.primary)
            });
        }));
        if (isEmails) {
            contactItemsArray.setValidators(ContactItemValidator.emailAddressDuplicated);
        }
        else {
            contactItemsArray.setValidators(ContactItemValidator.phoneNumberDuplicated);
        }
        this.contactForm.setControl(itemsName, contactItemsArray);
    };
    TabContactsComponent.prototype.addNewContactItem = function (itemsName) {
        var itemsNameIsEmail = Boolean(itemsName === 'emails');
        var numberContactItems = this.contactForm.get(itemsName)['controls'].length;
        var contactItemsArray = this.contactForm.get(itemsName);
        var newContactFormGroup = this.fb.group({
            contactType: this.fb.control('work', Validators.required),
            primary: this.fb.control(numberContactItems ? false : true)
        });
        if (itemsNameIsEmail) {
            newContactFormGroup.setControl('emailAddress', this.fb.control(null, [Validators.required, Validators.email]));
            newContactFormGroup.setControl('name', this.fb.control(null));
            contactItemsArray.setValidators(ContactItemValidator.emailAddressDuplicated);
        }
        else {
            newContactFormGroup.setControl('number', this.fb.control(null, Validators.required));
            newContactFormGroup.setControl('name', this.fb.control(null));
            contactItemsArray.setValidators(ContactItemValidator.phoneNumberDuplicated);
        }
        var lastPosition = contactItemsArray.length;
        contactItemsArray.setControl(lastPosition, newContactFormGroup);
        var inputId = "contact-" + itemsName + "-" + lastPosition;
        setTimeout(function () { return document.getElementById(inputId).focus(); }, 0);
    };
    TabContactsComponent.prototype.removeContactItem = function (itemsName, itemIndex) {
        var contactItemArray = this.contactForm.get(itemsName);
        contactItemArray.removeAt(itemIndex);
        var numberContactItemArray = contactItemArray.controls.length;
        var numberContactItemsPrimary = contactItemArray.value.filter(function (contactItem) { return (contactItem.primary === true); }).length;
        if (numberContactItemArray && !numberContactItemsPrimary) {
            contactItemArray.at(0).get('primary').setValue(true);
        }
    };
    TabContactsComponent.prototype.changePrimaryContactItem = function (itemsName, itemIndex) {
        var contactItemArray = this.contactForm.get(itemsName);
        var contactItem = contactItemArray.at(itemIndex);
        var isPrimary = contactItem.get('primary').value;
        var otherControls = contactItemArray.controls.filter(function (_control, index) { return index !== itemIndex; });
        if (isPrimary) {
            otherControls.forEach(function (control) { return control.get('primary').setValue(false); });
        }
        else {
            var control = otherControls[0] || contactItemArray.at(itemIndex);
            control.get('primary').setValue(true);
        }
    };
    return TabContactsComponent;
}());
export { TabContactsComponent };
